// eslint-disable-next-line no-useless-escape
export const REGEX_URL = `https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\\+~#=]{1,256}\\.[a-zA-Z0-9()]{1,6}\\b([-a-zA-Z0-9()@:%_\\+.~#?&//=]*)`;

export const REGEX_CUSTOM_VALUE = `[a-zA-Z0-9]+`;
export const REGEX_FALLBACK_VALUE = `[^:}<]*`;
export const ADDITIONAL_VALUE_LENGTH = 253;
